import Grid from "@material-ui/core/Grid";
import {FillerSection} from "../../FillerSection/FillerSection";
import {FormTable} from "../../FormTable/FormTable";
import React from "react";

export const FullNameSelectFiller = ({getFieldProps}) => {
    const mainInformationConfig = [
        {id: 'content.firstNameVariable', label: 'Имя'},
        {id: 'content.lastNameVariable', label: 'Фамилия'},
        {id: 'content.emailVariable', label: 'E-mail'},
        {id: 'content.midNameVariable', label: 'Отчество'},
        {id: 'content.appointmentVariable', label: 'Должность'},
        {id: 'content.phoneNumberVariable', label: 'Номер телефона'},
        {id: 'content.organizationVariable', label: 'Организация'},
    ]

    const casesConfig = [
        {id: 'content.appointmentToWhomVariable', label: 'Должность кому'},
        {id: 'content.appointmentByWhomVariable', label: 'Должность кем'},
        {id: 'content.appointmentWhomVariable', label: 'Должность кого'},
        {id: 'content.fullNameToWhomVariable', label: 'ФИО кому'},
        {id: 'content.fullNameByWhomVariable', label: 'ФИО кем'},
        {id: 'content.fullNameWhomVariable', label: 'ФИО кого'}, 
        {id: 'content.fullNameWhoVariable', label: 'ФИО кто'},
    ]
    
    return <Grid item container spacing={2}>
        <Grid xs={6} item container>
            <FillerSection title={'Общая информация'}>
                <FormTable config={mainInformationConfig} getFieldProps={getFieldProps}/>
            </FillerSection>
        </Grid>
        <Grid xs={6} item container>
            <FillerSection title={'Склонения ФИО/должности'}>
                <FormTable config={casesConfig} getFieldProps={getFieldProps}/>
            </FillerSection>
        </Grid>
    </Grid>
}